import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { EndPointService } from 'src/app/core/services/end-point.service';
import { PositionRequestLocalHrTask } from '../models/PositionRequestLocalHrTask';
import { TaskOverview } from '../models/TaskOverview';

@Injectable({
    providedIn: 'root',
})
export class LocalHrTasksService {
    private _baseUrl = '/api/localhrtasks/';
    private _baseUrlTaskSettings = '/api/framework/tasksettings/';
    private _saveUrlTaskSettings = 'SaveTaskSettings';

    constructor(private _endPointService: EndPointService) {
        this.registerEndPoints();
    }

    private registerEndPoints(): void {
        this._endPointService.registerEndPoint<TaskOverview>('GetLocalHrTasks', `${this._baseUrl}`, true);
        this._endPointService.registerEndPoint<PositionRequestLocalHrTask>('GetPositionFlowTask', `${this._baseUrl}detail/positionflow/`, true);
        this._endPointService.registerEndPoint<void>('AcceptPositionRequest', `${this._baseUrl}detail/positionflow/accept`, false);
        this._endPointService.registerEndPoint<void>('ReworkPositionRequest', `${this._baseUrl}detail/positionflow/rework`, false);
        this._endPointService.registerEndPoint<void>('DeletePositionRequest', `${this._baseUrl}detail/positionflow/delete`, false);
    }

    public getTasks(fetch?: boolean): Observable<TaskOverview> {
        return this._endPointService.call<TaskOverview>('GetLocalHrTasks', null, fetch);
    }

    public getPositionFlowTask(flowId: number, fetch?: boolean): Observable<PositionRequestLocalHrTask> {
        return this._endPointService.call<PositionRequestLocalHrTask>('GetPositionFlowTask', flowId, fetch);
    }

    public acceptPositionRequest(flowId: number, comment: string): Observable<void> {
        return this._endPointService.call<void>('AcceptPositionRequest', { flowId, comment });
    }

    public reworkPositionRequest(flowId: number, comment: string): Observable<void> {
        return this._endPointService.call<void>('ReworkPositionRequest', { flowId, comment });
    }

    public deletePositionRequest(flowId: number, comment: string): Observable<void> {
        return this._endPointService.call<void>('DeletePositionRequest', { flowId, comment });
    }
}